export function maskedCCNumber(card) {
    const splitCC = card?.maskedCardNumber?.split('-')
    return '**** ' + splitCC?.at(-1)
}
